<template>
  <v-row align="center" justify="center">
    <v-col class="px-10" cols="4">
      <v-card class="mx-auto pt-8" min-width="400">
        <v-col class="text-center">
          <img :src="require('@/assets/appLogo-color--Onlight.svg')" width="140">
          <span class="mt-5 d-block body-1 text--secondary font-weight-medium">Iniciar sesión</span>
        </v-col>
        <v-card-text>
          <v-form>
            <v-col class="pa-0">
              <span class="body-2 text--secondary font-weight-medium">Email</span>
              <v-text-field v-model="$v.user.email.$model" @keyup.enter="signIn" :error="$v.user.email.$error" outlined hide-details required single-line dense />
            </v-col>
            <v-col class="pa-0 my-6">
              <span class="body-2 text--secondary font-weight-medium">Contraseña</span>
              <v-text-field v-model="$v.user.password.$model" @keyup.enter="signIn" :error="$v.user.password.$error" outlined hide-details required single-line class="pa-0" dense type="password">
                <template v-slot:append>
                  <v-btn class="mt-n1 mr-1" :to="{name: 'AuthPasswordReset'}" text color="primary" small :ripple="false">¿la olvidaste?</v-btn>
                </template>
              </v-text-field>
            </v-col>
            <v-col v-if="error" class="pa-0 text-center">
              <v-alert border="left" colored-border color="white" dense class="body-2 red--text pa-0">{{error}}</v-alert>
            </v-col>
            <v-col class="my-6 pa-0">
              <v-btn @click="signIn" :loading="signInLoader" color="primary" height="40" block>Iniciar sesión</v-btn>
            </v-col>
          </v-form>
          <v-divider />
          <v-col class="text-center pa-0 mt-6">
            <v-btn @click="signInGoogle" retain-focus-on-click outlined height="40" block>
              <img :src="require('@/assets/appAsset-brand--GoogleLogo.svg')" width="24px" />
              <span class="ml-4">Iniciar sesión con Google</span>
            </v-btn>
            <span class="d-block text--secondary mt-5">¿No tienes una cuenta de Piriod?</span>
            <v-btn :to="{name: 'AuthSignUp'}" text color="primary" :ripple="false">Crea una cuenta gratis</v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
export default {
  data: () => ({
    user: {
      email: '',
      password: ''
    },
    error: '',
    signInLoader: false
  }),
  created () {
    if (this.$store.state.auth.user.authenticated) {
      this.$router.push({
        name: 'AccountDashboard'
      })
    }
  },
  methods: {
    identifyUser () {
      /**
       * retrieve user data to identify user
       * it runs as long as the env is production
       */
      if (process.env.NODE_ENV !== 'production') {
        return false
      }

      this.$store.dispatch('auth/GET_USER')
      .then((r) => {
        const traits = {
          email: r.data.email
        }

        const options = {
          integrations: {
            Intercom: {
              user_hash: r.data.intercom.hash
            }
          }
        }

        this.$analytics.identify(r.data.email, traits, options)
      })
    },
    signInGoogle () {
      this.$gAuth.getAuthCode()
      .then((code) => {
        this.$store.dispatch('auth/GET_AUTH', {
          resource: '/auth/google/',
          payload: {
            provider: 'google-oauth2',
            code: code
          }
        })
        .then(() => {
          this.identifyUser()

          this.$router.push({ name: 'AccountChoose' })
        })
      })
      .then((r) => {
        // after ajax
      })
    },
    signIn () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }

      this.signInLoader = true

      this.$store.dispatch('auth/GET_AUTH', {
        resource: '/token/',
        payload: {
          username: this.user.email,
          password: this.user.password
        }
      })
      .then(() => {
        this.identifyUser()

        this.$router.push({ name: 'AccountChoose' })
      })
      .catch((error) => {
        this.error = error.response.data.detail
      })
      .finally(() => {
        this.signInLoader = false
      })
    }
  },
  validations: {
    user: {
      email: {
        required,
        email,
        maxLength: maxLength(254)
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(64)
      }
    }
  }
}
</script>